import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ParcelMIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.57 3.143a1 1 0 0 1 1.036.004l7.916 4.85A1 1 0 0 1 21 8.85v6.063a1 1 0 0 1-.485.858l-8.084 4.85a1 1 0 0 1-1.037-.005l-7.916-4.85A1 1 0 0 1 3 14.913V8.85a1 1 0 0 1 .486-.857zM5 10.636l5.916 3.625v3.717L5 14.353zm7.916 7.361L19 14.347v-3.73l-6.084 3.65zm-.994-5.466 6.15-3.69-2.035-1.246-6.15 3.69zm-3.958-2.425 6.15-3.69-2.036-1.247-6.15 3.69z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
